import { OktaAuth } from '@okta/okta-auth-js';

export let oktaAuth : OktaAuth | null = null;

export const setOktaAuth = (value: OktaAuth | null) => {
    oktaAuth = value;
};